// extracted by mini-css-extract-plugin
export default {"reject":"Reject_reject__8sKxD"};